import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useLocation } from 'react-router-dom';
import Container from '../../common/components/Container/Container';
import TitleContainer from '../../common/components/TitleContainer/TitleContainer';
import { Routes } from '../../config/routes';
import { FlowConfigContext } from '../../providers/FlowConfigContext';
import Button, { ButtonStyle } from '../../common/components/Button/Button';
import ButtonContainer from '../../common/components/Button/ButtonContainer';
import { GatekeeperNetworkServiceContext } from '../../providers/GatekeeperNetworkService/GatekeeperNetworkServiceContext';

function RevocationDisclaimerScreen({ testId }: { testId: string }): JSX.Element {
  const { getExternalLinksConfig } = useContext(FlowConfigContext);
  const { civicSupportLink } = getExternalLinksConfig();
  const { burnCooldownPeriodLabel } = useContext(GatekeeperNetworkServiceContext);

  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();

  const handleContactSupport = () => {
    navigate(Routes.SUPPORT, { state: { from: location.pathname } });
  };

  const handleContinue = () => {
    navigate(Routes.FACE_SEARCH, { state: { from: location.pathname } });
  };

  return (
    <Container>
      <TitleContainer center>
        <h1 className="mb-2" data-testid={testId}>
          {t(`screens.revocation.title`)}
        </h1>
      </TitleContainer>
      <ul className="list-outside list-disc ml-7">
        <li className="text-primary mb-2">
          <span className="text-textNeutral">{t('screens.revocation.description.1')}</span>
        </li>
        <li className="text-primary">
          <span className="text-textNeutral">{t('screens.revocation.description.2', { burnCooldownPeriodLabel })}</span>
        </li>
      </ul>
      <ButtonContainer bottomMargin="mb-2 mt-4">
        <Button
          style={ButtonStyle.DEFAULT}
          disabled={false}
          loading={false}
          dataTestid="CONFIRM_SHARE_BUTTON"
          onClick={handleContinue}
        >
          <span>{t('screens.revocation.continueButton')}</span>
        </Button>
      </ButtonContainer>
      <span className="w-full whitespace-pre-wrap textDetail text-center mt-6">
        {t('common.support.supportLinkQuestions')}
        <a target="_blank" title="Help Center" href={civicSupportLink} className="textLinkDetail" rel="noreferrer">
          {t('common.support.supportLinkVisitHelpCenter')}
        </a>
        {t('common.support.supportLinkOr')}
        <button
          type="button"
          className="buttonLink"
          title="Contact support"
          onClick={handleContactSupport}
          data-testid="CONTACT_SUPPORT_BUTTON"
        >
          {t('common.support.supportLinkContactSupport')}
        </button>
      </span>
    </Container>
  );
}

export default (): JSX.Element =>
  RevocationDisclaimerScreen({
    testId: 'REVOCATION_DISCLAIMER_SCREEN',
  });
